module.exports = __webpack_public_path__ + "static/img/Weddle.26edda0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Weddle.jpg
// module id = VMrw
// module chunks = 0